
const state = {
  isLoading: true
}
const mutations = {
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

const actions = {

}


export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js